export default __webpack_public_path__ + "static/about-txt-chs-a5a817807553beabcbe3471dc27a8fa3.png";